<template>
  <div class="w-full">
    <div
      v-for="(tab, index) in steps"
      :key="`vertical-${tab.step}`"
      class="hidden md:flex flex-col items-stretch justify-start"
    >
      <div class="flex items-center justify-start gap-3">
        <svg-icon :iconName="tab.icon" :className="leftContentWidth" />
        <div :class="step >= tab.step ? 'bg-blueG0' : 'bg-[#9ea8b6]'" class="w-2 h-2 rounded-full" />
        <div
          :class="step >= tab.step ? 'text-blueG0 font-bold' : 'text-darkBlueG0'"
          class="flex-1 text-sm leading-snug"
        >
          {{ $t(tab.title) }}
        </div>
      </div>
      <div v-if="index < steps.length - 1" class="flex items-center justify-start gap-3">
        <div :class="leftContentWidth" />
        <div
          :class="step >= tab.step ? 'border-r-blueG0' : 'border-r-blackG4 opacity-40'"
          class="my-4 flex-none w-1 h-8 border-r border-r-dashed"
        />
      </div>
    </div>
    <div class="w-full flex items-center justify-between md:hidden">
      <template v-for="(tab, index) in steps">
        <div
          :key="`horizontal-${tab.step}`"
          :class="step >= tab.step ? 'bg-blueG0' : 'bg-[#9ea8b6]'"
          class="w-2 h-2 rounded-full"
        />
        <div
          :key="`horizontal-line-${tab.step}`"
          v-if="index < steps.length - 1"
          :class="step >= tab.step ? 'border-t-blueG0' : 'border-t-blackG4 opacity-40'"
          class="mx-4 flex-1 h-1 border-t border-t-dashed"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterStepper',
  props: {
    step: { type: Number, required: true },
    // Array<RegisterFormTab>
    steps: { type: Array, default: [] }
  },
  created() {
    const gap = 12;
    this.leftContentWidth = '!w-6 !h-6';
    this.gap = `gap-${gap / 4}`;
  }
};
</script>
